/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IShippingPopupData } from './shipping-popup.data';
import { IShippingPopupProps } from './shipping-popup.props.autogenerated';

import { observable } from 'mobx';
import { observer } from 'mobx-react';

export interface IShippingPopupViewProps extends IShippingPopupProps<IShippingPopupData> {
    modalState: boolean;
    toggleModal(): void;
}

/**
 *
 * ShippingPopup component
 * @extends {React.PureComponent<IShippingPopupProps<IShippingPopupData>>}
 */
@observer
class ShippingPopup extends React.PureComponent<IShippingPopupProps<IShippingPopupData>> {

    @observable private _modalState: boolean = false;

    constructor(props: IShippingPopupProps<IShippingPopupData>) {
        super(props);

        this._toggleModal = this._toggleModal.bind(this);
    }

    public render(): JSX.Element | null {
        return this.props.renderView({
            modalState: this._modalState,
            toggleModal: this._toggleModal,
            ...this.props
        });
    }

    private _toggleModal(): void {
        this._modalState = !this._modalState;
        if (typeof window !== 'undefined' && this._modalState === true) {
            const scrollbarWidth = window.innerWidth - document.body.clientWidth;
            document.body.style.top = `-${window.scrollY}px`;
            document.documentElement.style.setProperty('--windowScrollY', `-${window.scrollY}px`);
            document.documentElement.style.setProperty('--windowScrollBarWidth', `${scrollbarWidth}px`);
        }
    }
}

export default ShippingPopup;
